<template>
  <div class="home">
    <v-container-fluid>
      <v-layout row wrap>
        <v-flex class="mt-10 ml-7" xs5 md5 sm5 lg5>
          <h1 >Aspire Arrive Achieve </h1>
          <h4>build your skills to easily tackle the entrance exams</h4>
         
          
        
        </v-flex> 
        <v-flex xs6 md6 sm6 lg4>
          <h2 class="mt-13">Login into your profile</h2>
          <v-form ref="form"  class="mt-4 mr-8">
            <v-text-field label="Email" v-model="iglo" outlined></v-text-field>
            <v-text-field label="Password" v-model="passwrd" outlined></v-text-field>
            <v-btn class="ma-6" v-on:click.prevent="logsin" type="submit">Submit</v-btn>
          </v-form>
        </v-flex> 
      </v-layout>
    </v-container-fluid>
  </div>
</template>



<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import {auth} from '../components/firebaseinit'
import db from '../components/firebaseinit';
// import 'firebase/auth';
export default {
  
  name: 'Home',
  components: {
    
  },
  data(){
      return {
           iglo:null,
      passwrd:null,
      students:[],
      teacher:[]
    }
  },
  methods:{
    logsin:function(){
      console.log("hi")
      // console.log(this.iglo)
      // console.log(this.password)
      auth.signInWithEmailAndPassword(this.iglo,this.passwrd).then(user =>{
        console.log("hello")
        alert('You are logged in as '+ user.user.email);
         function check(arr){
          return arr==user.user.email;
        }
        if(this.teacher.filter(check).length>0)
        console.log(this.$router.go(this.$router.push('/t')))
        else
        console.log(this.$router.go(this.$router.push('/d')))
      
      
      }
      // .catch(err => {
      //   console.log(err)
      // }
      ,
      err =>{
        alert(err.message);
      });

      // e.preventDefault();
      
    }
  },
  beforeMount(){
    db.collection('teachers').get().then(snapShot => {
          snapShot.forEach(val => {
            console.log(val.data())
            this.teacher.push(val.data().Mail)
           

          })
        })
  }
}
</script>

<style scoped>

</style>
